import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d65377cc&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=d65377cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65377cc",
  null
  
)

component.options.__file = "App.vue"
export default component.exports